import React, { useState } from 'react'
import { Button, Steps, Card, message, Table, Tag } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import TremForm from './TremForm'
import FinishForm from './FinishForm'
import BrandForm from './BrandForm'
import UserForm from './UserForm'
import { Content, Action } from './styles'
import {
  updateUser
} from '../../modules/appUser'
import {
  createBrand
} from '../../modules/brand'
import _ from 'lodash'

const CreateBrand = (props) => {
  const { me } = props
  const dispatch = useDispatch()
  const [formDataBrand, setFormDataBrand] = useState({
    name: "",
    nameEng: "",
    address: "",
    taxId: "",
  })
  const [formDataUser, setFormDataUser] = useState({
    name: me.name,
    email: me.email,
    tel: me.tel
  })
  console.log(me)
  const { Step } = Steps;

  const steps = [
    {
      title: 'เงื่อนไขการใช้บริการ',
      content: <TremForm />,
    },
    {
      title: 'ข้อมูลพื้นฐาน',
      content: <BrandForm
        formDataBrand={formDataBrand}
        setFormDataBrand={setFormDataBrand} />,
    },
    {
      title: 'ข้อมูลผู้ติดต่อ',
      content: <UserForm
        formDataUser={formDataUser}
        setFormDataUser={setFormDataUser} />,
    },
    {
      title: 'เสร็จสิ้น',
      content: <FinishForm />,
    },
  ];

  const [current, setCurrent] = useState(0);



  console.log(formDataBrand)
  console.log(formDataUser)

  const next = () => {
    if (current == 0) {
      setCurrent(current + 1);
    }
    if (current == 1) {
      if (formDataBrand.name == "" || formDataBrand.nameEng == "" || formDataBrand.address == "" || formDataBrand.taxId == "") {
        message.error('กรุณากรอกข้อมูล Brand ให้ครบ')
      } else {
        setCurrent(current + 1);
      }
    }
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const finish = () => {
    message.success('ลงทะเบียนสร้าง Brand เรียบร้อย')
    localStorage.setItem('new_Brand', 1);
    setTimeout(() => {
      window.location.href = "/";
    }, 1000)
  };

  const onOk = async () => {
    if (formDataUser.name == "" || _.isEmpty(formDataUser.tel) || formDataUser.email == "" || formDataUser.tel == "") {
      message.error('กรุณากรอกข้อมูลผู้ติดต่อให้ครบ')
    } else {
      if (!_.isEmpty(formDataBrand)) {
        await dispatch(createBrand(formDataBrand))
      }
      if (!_.isEmpty(formDataUser)) {
        await dispatch(updateUser(formDataUser))
      }
      setCurrent(current + 1);
    }
  }
  return (
    <Card
      title="สร้างแบรนด์">
      <Steps current={current}>
        {steps.map(item => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      <Content>{steps[current].content}</Content>
      <Action>
        {current > 0 && (
          current === 3 ?
            <div></div>
            :
            <Button onClick={() => prev()}>
              กลับ
            </Button>
        )}
        {current < steps.length - 1 && (
          current === 2 ?
            <Button style={{ marginLeft: 8 }} type="primary" onClick={() => onOk()}>
              ลงทะเบียน
            </Button>
            :
            <Button style={{ marginLeft: 8 }} type="primary" onClick={() => next()}>
              ต่อไป
            </Button>
        )}
        {current === steps.length - 1 && (
          <Button type="primary" style={{ marginLeft: 8 }} onClick={() => finish()}>
            เสร็จสิ้น
          </Button>
        )}
      </Action>
    </Card>
  )
}

export default CreateBrand



// WEBPACK FOOTER //
// ./src/pages/CreateBrand/index.js